export interface IResponseError {
  title: string;
  status: string;
  detail?: string;
  source?: { parameter?: string; id?: string };
  id?: ErrorResponseIdEnum;
}

export enum ErrorResponseIdEnum {
  LIMIT_EXCEEDED = "limit_exceeded",
}

export enum ErrorCodeEnum {
  SERVER_ERROR = 500,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  NOT_FOUND = 404,
  CONFLICT = 409,
  SERVICE_UNAVAILABLE = 503,
}

export interface IError {
  message: string;
  error: string;
}
